import React from 'react';
import PropTypes from 'prop-types';
import { connect } from "react-redux";

import { closeGlobalNotification } from "./actions";

import {
    NOTIFICATION_SUCCESS,
    NOTIFICATION_ERROR,
} from './constants';

class GlobalNotification extends React.Component {

    componentDidMount() {
        this.intervalToHideNotification = null;
        this.intervalToHideNotificationSecondsCount = 10000;
    }

    componentDidUpdate(prevProps) {
        const { isOpen, message } = this.props;
        const messageChangedWhileNotificationIsOpen = (prevProps.message !== message) && isOpen === true;
        const notificationWasRevealed = prevProps.isOpen === false && isOpen === true;

        if (notificationWasRevealed) {
            this.closeAfterIntervalEnds();
        }

        if (messageChangedWhileNotificationIsOpen) {
            this.resetInterval();
        }
    }

    resetInterval = () => {
        clearInterval(this.intervalToHideNotification);
        this.closeAfterIntervalEnds();
    }

    closeAfterIntervalEnds = () => {
        const { closeGlobalNotificationAction } = this.props;

        this.intervalToHideNotification = setTimeout(function() {
            closeGlobalNotificationAction();
        }, this.intervalToHideNotificationSecondsCount);
    }

    getNotificationKeyFromKey = (notificationKey) => {
        if (notificationKey === NOTIFICATION_SUCCESS) return 'alert-success';
        if (notificationKey === NOTIFICATION_ERROR) return 'alert-danger';
        return false;
    }

    render () {
        const { message, isOpen, notificationKey } = this.props;
        const notificationClasses = this.getNotificationKeyFromKey(notificationKey);

        if (!isOpen)
            return false;

        return (
            <div className={`global-notification-bar alert ${notificationClasses}`}>{message}</div>
        );
    }
};

GlobalNotification.propTypes = {
    message: PropTypes.string.isRequired,
    isOpen: PropTypes.bool.isRequired,
    notificationKey: PropTypes.string.isRequired,
    closeGlobalNotificationAction: PropTypes.func.isRequired,
};

GlobalNotification.defaultProps = {};

const mapStateToProps = (state) => {
    const { message, isOpen, notificationKey } = state.globalNotifications;
    return {
        message,
        isOpen,
        notificationKey,
    }
};

const mapDispatchToProps = (dispatch) => ({
    closeGlobalNotificationAction: () => dispatch(closeGlobalNotification()),
});

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(GlobalNotification);